import axios from 'axios'
import { cancelPreviousRequest } from '../../component/helper'
const API_URL = process.env.REACT_APP_THEME_API_URL
const GET_OFFER_URL = `${API_URL}/project-offer-detail`
const GET_SUB_OFFER_URL = `${API_URL}/project-sub-offer-detail`
const SAVE_OFFER_URL = `${API_URL}/project-offer-add`
const SAVE_SUB_OFFER_URL = `${API_URL}/project-sub-offer-add`
const UPDATE_SUB_OFFER = `${API_URL}/project-sub-offer-edit`
const GET_OFFER_LIST = `${API_URL}/project-offer-list`
const GET_SUB_OFFER_LIST = `${API_URL}/project-sub-offer-list`
const UPDATE_OFFER = `${API_URL}/project-offer-edit`
const GET_CAT_AND_SUBCAT = `${API_URL}/get-cat-and-subcat-by-comapny`
const MAP_OFFER_PRODUCT = `${API_URL}/map-offer-product`
const STRUCTURE_WITH_OFFICES = `${API_URL}/structures-with-offices`
const PROJECT_OFFER_BONUS = `${API_URL}/project-offer-bonus`

const CREATE_PARENT_OFFER_URL = `${API_URL}/create-parent-offer`
const CREATE_OFFER_URL = `${API_URL}/create-new-offer`
const STURUCTURE_WITH_HIERARCHY_URL = `${API_URL}/structure-with-hierarchy`
const PRODUCT_BY_CATEGORY_URL = `${API_URL}/get-product-by-category`
const GET_OFFER_GROUPS = `${API_URL}/get-offer-groups`
const GET_OFFER_DETAIL = `${API_URL}/project-offer-detail`
const GET_SUB_OFFER_PRODUCT_GROUP_BY_ID = `${API_URL}/get-sub-offer-product-group-by-id`
const GET_OFFER_GROUP_LIST = `${API_URL}/project-offer-group-list`
const PROJECT_OFFER_ALL = `${API_URL}/project-offer-all`
const PROJECT_COLLECTIVE_REPORT_URL = `${API_URL}/npp-offer-report-url`
const Offer_Abort = `${API_URL}/abort-offer`

export const getProjectCollectiveReportUrl = () => {
    return axios.get(`${PROJECT_COLLECTIVE_REPORT_URL}`).then((d) => d.data)
}
export const getProjectOfferAll = (query) => {
    return axios.get(`${PROJECT_OFFER_ALL}?${query}`).then((d) => d.data)
}
export const getProjectOfferDetail = (id) => {
    return axios.get(`${GET_OFFER_DETAIL}/${id}`).then((d) => d.data)
}
export const getProjectOfferGroupByParentOfferId = (parentOfferId) => {
    return axios.get(`${GET_OFFER_GROUP_LIST}/${parentOfferId}`).then((d) => d.data)
}
export const getAllProjectOffer = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${GET_OFFER_LIST}?${query}`, { signal }).then((d) => d.data)
}
export const getAllProjectSubOffer = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${GET_SUB_OFFER_LIST}?${query}`, { signal }).then((d) => d.data)
}
export const createProjectOffer = (data) => {
    return axios
        .post(SAVE_OFFER_URL, data)
        .then((response) => response.data)

}
export const updateProjectOffer = (data) => {
    return axios
        .post(UPDATE_OFFER, data)
        .then((response) => response.data)

}

export const createProjectSubOffer = (data) => {
    return axios
        .post(SAVE_SUB_OFFER_URL, data)
        .then((response) => response.data)
}

export const updateProjectSubOffer = (data) => {
    return axios
        .post(UPDATE_SUB_OFFER, data)
        .then((response) => response.data)
}

export const getEditProjectOfferId = (id) => {
    return axios
        .get(`${GET_OFFER_URL}/${id}`)
        .then((response) => response.data)
        .then((response) => response.data)
}
export const getEditProjectSubOfferId = (id) => {
    return axios
        .get(`${GET_SUB_OFFER_URL}/${id}`)
        .then((response) => response.data)
        .then((response) => response.data)
}
export const getCatAndSubcat = () => {
    return axios
        .post(`${GET_CAT_AND_SUBCAT}`)
        .then((response) => response.data);
};
export const mapOfferProduct = (data) => {
    return axios
        .post(MAP_OFFER_PRODUCT, data)
        .then((response) => response.data)

}
export const structureWithOffice = () => {
    return axios
        .get(STRUCTURE_WITH_OFFICES)
        .then((response) => response.data)

}
export const projectOfferBonus = (data) => {
    return axios
        .post(PROJECT_OFFER_BONUS, data)
        .then((response) => response.data)

}
// New API integrations.
export const getStructureWithHierarcy = (query) => {
    return axios.get(`${STURUCTURE_WITH_HIERARCHY_URL}`).then((d) => d.data)
}

export const getProjectByCategory = (query) => {
    return axios.get(`${PRODUCT_BY_CATEGORY_URL}`).then((d) => d.data)
}

export const getOfferGroupList = (query) => {
    return axios.get(`${GET_OFFER_GROUPS}`).then((d) => d.data)
}

export const createEditParentOffer = (data) => {
    return axios
        .post(CREATE_PARENT_OFFER_URL, data)
        .then((response) => response.data)
}

export const createEditOffer = (data) => {
    return axios
        .post(CREATE_OFFER_URL, data)
        .then((response) => response.data)
}
export const getSubOfferProductGroupById = (data) => {
    return axios
        .post(GET_SUB_OFFER_PRODUCT_GROUP_BY_ID, data)
        .then((response) => response.data)
}

export const abortNppOffer = (data) => {
    return axios
        .post(Offer_Abort, data)
        .then((response) => response.data)
}